document.addEventListener("DOMContentLoaded", function () {
  const EMPTY_TEXT = "_EMPTY_";

  function cleanEmptyReviews() {
    document
      .querySelectorAll(".jdgm-review-content__body-content")
      .forEach(function (el) {
        const text = el.textContent.trim();

        if (text === EMPTY_TEXT) {
          el.innerHTML = "";
          el.style.display = "none";
        }
      });
  }

  // הרצה ראשונית
  cleanEmptyReviews();

  // Judge.me נטען דינמית – מאזין לשינויים
  const observer = new MutationObserver(cleanEmptyReviews);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
